<div class="unauthorized-container">
  <h1>403 - Unauthorized</h1>
  <p>You do not have permission to access this page.</p>
  <button mat-raised-button color="primary" routerLink="/">Go to Home</button>
</div>
